import AdminIssuesPage from './AdminIssuesPage'
export default AdminIssuesPage
